import { render, staticRenderFns } from "./ReplaceForm.vue?vue&type=template&id=5ef9b883&scoped=true&"
import script from "./ReplaceForm.vue?vue&type=script&lang=js&"
export * from "./ReplaceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef9b883",
  null
  
)

export default component.exports